export interface EmailRecipient {
  key: string;
  email: string;
  nome: string;
  ativo: boolean;
  rejeitado?: boolean;
}

export type EmailMode = "default" | "custom";

export interface EmailFormData {
  enabled: boolean;
  recipients: EmailRecipient[];
  mode: EmailMode;
  assunto: string;
  corpo: string;
}

export interface EmailVariable {
  token: string;
  placeholder: string;
  label: string;
  grupo: string;
  exemplo: string;
}

export interface EmailVariablesCatalog {
  variaveis: EmailVariable[];
  grupos: Record<string, EmailVariable[]>;
  templatePadrao: { assunto: string; corpo: string };
}

export interface EmailPreviewResponse {
  assunto: string;
  html: string;
  text: string;
  avisos: string[];
  htmlFoiAlterado: boolean;
  tamanhoHtml: number;
  usouDadosReais: boolean;
}

export interface EmailSend {
  id: string;
  destinatario: string;
  nomeDestinatario: string | null;
  agendamentoTitulo: string;
  etapa: number;
  dataGeracao: string;
  status: number;
  statusLabel: string;
  tentativas: number;
  proximaTentativa: string | null;
  anexado: boolean;
  tamanhoAnexo: number | null;
  messageId: string | null;
  erro: string | null;
  enviadoEm: string | null;
  createAt: string;
}

export interface BackendRecipient {
  id?: string;
  email: string;
  nome?: string | null;
  ativo: boolean;
}

export interface BackendEmailConfig {
  assunto: string | null;
  corpo: string | null;
  Destinatarios?: BackendRecipient[];
}

export const MAX_RECIPIENTS = 20;
export const MAX_SUBJECT = 200;
export const MAX_BODY_BYTES = 100 * 1024;

export const emptyEmailForm: EmailFormData = {
  enabled: false,
  recipients: [],
  mode: "default",
  assunto: "",
  corpo: "",
};
